import { Typography } from "@lyfegen-platform/react-common";
import { Box, IconButton } from "@material-ui/core";
import { Link as LinkIcon } from "@material-ui/icons";
import { isBefore } from "date-fns";
import { sub } from "date-fns/esm";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { SupportedMessageNodes } from "../../../models/generated/graphql";
import { userPersonalInfoState } from "../../../store/user";
import useMessagesStyles from "./use-messages-styles";
import Dot from "../../../components/icons/Dot";
import CaseMessageContent from "./CaseMessageContent";
import CaseMessageDeletion from "./CaseMessageDeletition";
import { localeDateTime } from "../../../utils/locale-date-time";
import { useTranslation } from "react-i18next";
import { SingleMessage } from "./CaseMessages";
import LyfeAvatar from "../../../components/LyfeAvatar";

export interface MessageProps {
	message: SingleMessage;
	nodeId: string;
	nodeLabel: SupportedMessageNodes;
	deleteMessageCondition: boolean;
}

const CaseMessage: React.FC<MessageProps> = ({ message, nodeId, nodeLabel, deleteMessageCondition }) => {
	const { t } = useTranslation();
	const { messageStyle, smallFont, smallFontSecondary } = useMessagesStyles();
	const [showCopyLink, setShowCopyLink] = useState(false);

	const userData = useRecoilValue(userPersonalInfoState);

	const handleCopyUrl = () => {
		const { origin, pathname, search } = window.location;
		const searchValue = search ? `${search}&` : "?";
		const copyUrl = `${origin}${pathname}${searchValue}thread=${nodeId}&message=${message.createdOn}`;
		navigator.clipboard.writeText(copyUrl);
	};

	const messageDate = new Date(message.createdOn || 0);
	const canDeleteMessage: boolean =
		isBefore(sub(new Date(), { hours: 24 }), messageDate) && message.sentBy.id === userData.id && deleteMessageCondition;

	return (
		<Box onMouseOver={() => setShowCopyLink(true)} onMouseLeave={() => setShowCopyLink(false)}>
			<Box className={messageStyle}>
				<Box display="flex" alignItems="center">
					<LyfeAvatar
						hideTooltip
						userId={message.sentBy.id}
						avatarStyle={{ marginLeft: "-40px" }}
						size="small"
						firstName={message.sentBy.firstName}
						lastName={message.sentBy.lastName}
					/>
					<Box display="flex" pl={1} pr={1}>
						<Typography classes={{ root: smallFont }} type="semi-bold">
							{message.sentBy.isDeleted ? t("deleted-user") : `${message.sentBy.firstName} ${message.sentBy.lastName}`}
						</Typography>
					</Box>
					<Dot />
					<Box display="flex" pl={1}>
						<Typography
							classes={{ root: smallFontSecondary }}
							style={{
								marginLeft: "2px",
							}}
							type="semi-bold"
						>
							{message.sentBy.organization.name}
						</Typography>
					</Box>
				</Box>
				<IconButton
					size="small"
					onClick={handleCopyUrl}
					style={{
						marginRight: "-10px",
						display: showCopyLink ? "inline" : "none",
					}}
				>
					<LinkIcon color="primary" />
				</IconButton>
			</Box>
			<Box paddingLeft={3}>
				<CaseMessageContent content={message.content || ""} />
				<Box display="flex" justifyContent="space-between">
					<Typography
						classes={{ root: smallFontSecondary }}
						style={{
							marginTop: "10px",
						}}
					>
						{`${localeDateTime(messageDate)}`}
					</Typography>
					{canDeleteMessage && <CaseMessageDeletion message={message} nodeId={nodeId} nodeLabel={nodeLabel} />}
				</Box>
			</Box>
		</Box>
	);
};

export default CaseMessage;
